export const contentTableConfig = {
  title: '复播视频列表',
  propList: [
    { prop: 'title', label: '标题', minWidth: '140' },
    { prop: 'cover', label: '封面', minWidth: '80', slotName: 'cover' },
    {
      prop: 'materialDeptType',
      label: '部门',
      minWidth: '80',
      slotName: 'materialDeptType'
    },
    {
      prop: 'materialType',
      label: '素材分类',
      minWidth: '90',
      slotName: 'materialType'
    },
    { prop: 'id', label: '复制链接', minWidth: '90', slotName: 'generate' },
    { prop: 'teacherName', label: '老师名', minWidth: '80' },
    { prop: 'courseName', label: '课程名', minWidth: '100' },
    {
      prop: 'createdTime',
      label: '创建时间',
      minWidth: '160',
      slotName: 'createdTime'
    },
    {
      label: '操作',
      minWidth: '240',
      slotName: 'handler',
      isFixed: 'right'
    }
  ],
  showIndexColumn: false,
  showSelectColumn: false
}
